import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Textarea,
  useDisclosure,
} from '@elkaso-app/web-design';
import { useApproveCreditUtilizationApi, useGetCreditUtilizationApi } from 'apis/bnpl';
import React from 'react';
import { useForm } from 'react-hook-form';

interface ApproveUtilizationModalProps {
  trigger: JSX.Element;
  utilizationId: number;
}

interface FormInputs {
  notes: string;
}

export const ApproveUtilizationModal = ({ trigger, utilizationId }: ApproveUtilizationModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate, isLoading } = useApproveCreditUtilizationApi();
  const { refetch } = useGetCreditUtilizationApi(utilizationId, { enabled: false });

  const { register, handleSubmit, reset } = useForm<FormInputs>({
    defaultValues: { notes: '' },
  });

  const onCloseModal = () => {
    reset({ notes: '' });
    onClose();
  };

  const onSubmit = (data: FormInputs) => {
    mutate(
      { utilizationId, body: { notes: data.notes || undefined } },
      {
        onSuccess: () => {
          refetch();
          onCloseModal();
        },
      }
    );
  };

  return (
    <>
      {React.cloneElement(trigger, { onClick: onOpen })}

      <Modal isOpen={isOpen} onClose={onCloseModal} closeOnOverlayClick={false} size='md'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Approve Utilization</ModalHeader>
          <ModalBody>
            <Stack as='form' id='approveUtilizationForm' spacing='lg' onSubmit={handleSubmit(onSubmit)} noValidate>
              <FormControl>
                <FormLabel>Notes (optional)</FormLabel>
                <Textarea {...register('notes')} placeholder='e.g., Verified against supplier records' />
              </FormControl>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <HStack spacing='md'>
              <Button variant='outline' colorScheme='red' onClick={onCloseModal}>
                Cancel
              </Button>
              <Button
                variant='solid'
                colorScheme='green'
                type='submit'
                form='approveUtilizationForm'
                isLoading={isLoading}>
                Approve
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
